'use client'
import Image, { StaticImageData } from 'next/image'
import Link from 'next/link'
import { isValidElement, ReactNode, useMemo } from 'react'
import circleImg from 'src/assets/circle.png'
import CaseStudyCard from 'src/components/CaseStudy/Card'
import DemoButton from 'src/components/DemoButton'
import * as rawCaseStudies from 'src/utils/case-studies'
import { CaseStudy as RawCaseStudy } from 'src/utils/case-studies'
import {
  AYGchargebacks,
  Fixe,
  KGRchargebacks,
  On_demand,
  Ops_Reports
} from 'src/utils/case-study'

export const Card = ({
  icon,
  title,
  subtitle,
  img,
  bgcolor,
  link,
  width
}: {
  bgcolor: string | undefined
  icon: StaticImageData | string | ReactNode
  title: string | undefined
  subtitle: string | undefined
  img: StaticImageData | string
  link: string | undefined
  width?: string | undefined
}) => (
  <Link
    href={`/case-study/${link}`}
    style={{ height: '100%', transition: '0.4s' }}
    className="hover:shadow-2xl"
    shallow={true}>
    <div
      style={{ background: bgcolor, height: '100%' }}
      className={`rounded-lg bg-[${bgcolor}] overflow-hidden flex flex-col justify-between`}>
      <div className="p-5">
        {isValidElement(icon) ? (
          icon
        ) : (
          <Image
            src={icon as StaticImageData}
            style={{ width: 20, height: 20 }}
            alt="store availability"
            width={20}
            height={20}
          />
        )}
        <h6 className="text-xs md:text-sm font-normal my-2">{title}</h6>
        <h2 className="text-sm md:text-lg font-semibold">{subtitle}</h2>
      </div>
      <div
        className={`${width ? `w-[${width}]` : 'w-[90%]'} h-[250px] ml-auto`}>
        <div className="relative w-full h-full">
          <Image
            className=" object-cover"
            style={{
              objectPosition: '0px 0px'
            }}
            fill
            alt="store availability"
            src={img}
          />
        </div>
      </div>
    </div>
  </Link>
)

export default function CaseStudy() {
  const caseStudies = useMemo(() => {
    return Object.values(rawCaseStudies).filter(
      (study): study is RawCaseStudy =>
        'slug' in study &&
        'id' in study &&
        'title' in study &&
        'testimonial' in study
    )
  }, [])

  return (
    <div>
      <div
        className="p-10 md:p-20 relative"
        style={{ background: '#F4F6F5', overflow: 'hidden' }}>
        <h3 className="text-2xl md:text-6xl">
          <span className="font-bold">
            CASE <br />
            STUDIES
          </span>
        </h3>
        <Image
          src={circleImg}
          alt="circles"
          style={{
            position: 'absolute',
            right: -200,
            height: 400,
            width: 'auto',
            top: -50
          }}
        />
      </div>
      <div className="p-10 md:p-20 bg-white">
        <div
          className="flex mb-5"
          style={{
            overflowY: 'auto'
          }}></div>
        <div className="grid mt-10 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {caseStudies.map((study) => (
            <CaseStudyCard key={study.id} study={study} />
          ))}

          <Card
            icon={KGRchargebacks.logo}
            title={KGRchargebacks.title1}
            subtitle={KGRchargebacks.title2}
            img={KGRchargebacks.heroImg}
            bgcolor={KGRchargebacks.bgColor}
            link="rallys-az-reduces-order-errors-and-chargebacks-by-60-using-loop"
          />
          <Card
            icon={Ops_Reports.logo}
            title={Ops_Reports.title1}
            subtitle={Ops_Reports.title2 + ' ' + Ops_Reports.title3}
            img={Ops_Reports.heroImg2}
            bgcolor={Ops_Reports.bgColor}
            link="empowering-the-frontline-MIXTs-use-of-loop-to-empower-store-managers"
          />
          <Card
            icon={On_demand.logo}
            title={On_demand.title1}
            subtitle={On_demand.title2 + ' ' + On_demand.title3}
            img={On_demand.heroImg2}
            bgcolor={On_demand.bgColor}
            width={'100%'}
            link="the-on-demand-company-a-digital-transformation-journey"
          />
          <Card
            icon={AYGchargebacks.logo}
            title={AYGchargebacks.title1}
            subtitle={AYGchargebacks.title2}
            img={AYGchargebacks.heroImg}
            bgcolor={AYGchargebacks.bgColor}
            link="how-ayg-group-halals-and-laynes-solved-order-accuracy-issues"
          />
          <Card
            icon={Fixe[0]?.listPageIcon || ''}
            title={Fixe[0]?.listPageTitle || ''}
            subtitle={Fixe[0]?.listPageSubTitle || ''}
            img={Fixe[0]?.listPageImg || ''}
            bgcolor={Fixe[0]?.bgColor || ''}
            link="how-fixe-automated-3pd-revenue-reconciliation"
          />
          {/* <Card
            icon={<Campaign />}
            title={RandRTruROI.title1}
            subtitle={RandRTruROI.title2}
            img={RandRTruROI.heroImg}
            bgcolor={RandRTruROI.bgColor}
            link="thriving-in-a-world-of-3pd-marketing-with-data-driven-precision"
          /> */}
        </div>
        <h5 className="text-base md:text-3xl font-normal text-center mt-28">
          Exceptional technology based on AI and Big Data
        </h5>
        <div className="flex text-center w-full mt-4">
          <DemoButton />
        </div>
      </div>
    </div>
  )
}